import React, { useState, useContext } from 'react';
import { addcontext } from '../../ContextShare/ContextShare';
// import DatePicker from 'react-datepicker';
// import { Icon } from '@iconify/react';
import { ToastContainer, toast } from 'react-toastify'
import { AddMembers } from '../../Services/allApi';
// import PopOver from '../../Components/PopOver';
import InfoIcon from '../../Components/InfoIcon'

function AddNewMember() {
    const { addMember, setaddMember } = useContext(addcontext);
    const [memberData, setMemberData] = useState({
        member_name: '',
        mal_member_name: '',
        member_image: null,
        member_start_date: null,
        member_end_date: null,
        is_non_member: false,
        sorting_name:''
    });

    const [imagePreview, setImagePreview] = useState('');

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setMemberData({ ...memberData, member_image: file });
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSave = async () => {
        const formData = new FormData();
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Authorization": `${token}`
        };

        // Append member data to formData
        formData.append('member_name', memberData.member_name);
        formData.append('member_start_date', memberData.member_start_date);
        formData.append('is_non_member', memberData.is_non_member);

        // Check if member_end_date exists and append to formData if so
        if (memberData.member_end_date) {
            formData.append('member_end_date', memberData.member_end_date);
        }
        if(memberData?.sorting_name){
            formData.append('sorting_name',memberData.sorting_name)
        }
        // Append image file if it exists
        if (memberData.member_image instanceof File) {
            formData.append('member_image', memberData.member_image);
        }

        if(memberData.mal_member_name){
            formData.append('mal_member_name',memberData.mal_member_name)
        }

        console.log(formData);

        try {
            const result = await AddMembers(formData, reqHeader);
            console.log(result);
            if (result?.status ===200) {
                toast.success("Member added successfulyy")
                setMemberData({
                    member_name: '',
                    mal_member_name:'',
                    member_image: null,
                    member_start_date: null,
                    member_end_date: null,
                    is_non_member: false,
                    sorting_name:''
                })
                setImagePreview('')      
                setTimeout(()=>{
                    setaddMember(false)
                },1000)
            }
            else {
                 // console.log(res?.response?.data?.message);
                 const messageData = result?.response?.data?.message;
                 // Check if messageData is an object
                 const errorMessage = typeof messageData === 'object' && messageData !== null
                     ? messageData[Object.keys(messageData)?.[0]]?.[0] // Get the first message from the object
                     : messageData; // If it's a string, use it directly
                 // console.log(errorMessage);
 
 
                 toast.error(errorMessage??"There was a problem adding member");
             
                // alert(errorMessage??"There was a problem adding member")
            }
        } catch (error) {
            console.error('Error adding member:', error);
            // Handle error, display error message, etc.
        }
    };


    return (<>
        <div className='w-full flex items-center flex-col'>
            <h3 className='text-blue-700 text-xl font-bold mt-10 mb-10 text-center'>Enter Member Details</h3>

            <div className='w-full items-center flex-col flex'>
                <label htmlFor="memberimage" className='w-2/12 h-40 cursor-pointer'>
                    <div className='bg-success border-dashed border-2 mb-10 h-full overflow-hidden p-2 rounded border-light-blue-600 flex justify-center items-center flex-col'>
                        {imagePreview ? (
                            <img className='h-full w-full' src={imagePreview} alt="Uploaded Preview" />
                        ) : (
                            <>
                                <img className='h-7/12 w-7/12' src="https://cdn2.iconfinder.com/data/icons/dottie-user-part-1/24/user_003-upload-profile-account-people-arrow-512.png" alt="Upload Icon" />
                                <span className='text-blue-500 underline'>Upload profile image</span>
                            </>
                        )}
                    </div>
                </label>
                <input id='memberimage' type="file" style={{ visibility: 'hidden' }} onChange={handleImageUpload} />
            </div>

            <div className='flex flex-row justify-center flex-wrap mb-10 w-full gap-3'>
                <div className='w-2/12 flex flex-col'>
                    <label htmlFor="membername">Member Display Name</label>
                    <input
                        id='membername'
                        placeholder='Display name'
                        value={memberData.member_name}
                        onChange={(e) => setMemberData({ ...memberData, member_name: e.target.value })}
                        type="text"
                        className='w-full h-10 rounded-lg border border-gray-700 px-2'
                    />
                </div>

                <div className='w-2/12 flex flex-col'>
                    <label htmlFor="membername">Display Name in Malayalam</label>
                    <input
                        id='membername'
                        placeholder='Display name malayalam'
                        value={memberData.mal_member_name}
                        onChange={(e) => setMemberData({ ...memberData, mal_member_name: e.target.value })}
                        type="text"
                        className='w-full h-10 rounded-lg border border-gray-700 px-2'
                    />
                </div>

                <div className='w-2/12 flex flex-col'>
                    <label htmlFor="membername"><span className='flex flex-row items-center'><span>Sorting Name</span> <InfoIcon content={'Sorting namr is used to sort the members '} /></span> </label>
                    <input
                        id='membername'
                        placeholder='Sorting name'
                        value={memberData.sorting_name}
                        onChange={(e) => setMemberData({ ...memberData, sorting_name: e.target.value })}
                        type="text"
                        className='w-full h-10 rounded-lg border border-gray-700 px-2'
                    />
                </div>

                <div className='w-2/12 flex flex-col'>
                    <label htmlFor='startdate' >Date of the member joined in kla </label>
                    <input
                        type='date'
                        id='startdate'
                        value={memberData.member_start_date}
                        onChange={(e) => setMemberData({ ...memberData, member_start_date: e.target.value })}
                        className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        isClearable
                    />
                </div>

                <div className='w-2/12 flex flex-col'>
                    <label htmlFor='enddate'>Ending date of the member in kla</label>
                    <input
                        type='date'
                        id='enddate'
                        value={memberData.member_end_date}
                        onChange={(e) => setMemberData({ ...memberData, member_end_date: e.target.value })}
                        className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        isClearable
                    />
                </div>

                <div className='flex flex-col'>
                    <label htmlFor='nonmember'><span className='flex flex-row items-center'><span>Non Member</span><InfoIcon content={"Not a member in the house eg:'Governer'"} /></span></label>

                    <input
                        id='nonmember'
                        type='checkbox'
                        checked={memberData.is_non_member}
                        onChange={(e) => setMemberData({ ...memberData, is_non_member: e.target.checked })}
                        className='h-10 rounded-lg border border-gray-700 px-2'
                    />

                </div>

                {/* <div className='flex flex-col justify-center -ms-3'>
                    <Icon icon="ic:twotone-info" className='text-lg text-blue-700' onClick={() => toast.info("Not a member in the house eg:'Governer'")} />



                    <input
                        style={{ visibility: 'hidden' }}
                        id='nonmember'
                        type='checkbox'
                        checked={memberData.is_non_member}
                        onChange={(e) => setMemberData({ ...memberData, is_non_member: e.target.checked })}
                        className='h-10 rounded-lg border border-gray-700 '
                    />

                </div> */}

            </div>

            <br />
            <div className='w-2/12'>
                <button className='w-full py-2 bg-primary text-white rounded-full' onClick={handleSave}>Save</button>
            </div>
        </div>

        {/* <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
        theme="light"
      /> */}
    </>
    );
}

export default AddNewMember;
